module.exports = __webpack_public_path__ + "img/geo-icon.e4f19221.png";